import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Avatar, Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import Typography from 'components/Typography';
import { agentConfig, mainConfig, otherConfig } from './SidebarConfig';
import {
  colors,
  displayFlexAlignItemsCenterJustifyContentCenter,
  displayFlexAlignItemsCenterJustifyContentSpaceBetween,
  tokens,
} from 'styles';

import calenderSvg from 'assets/images/drawer/calender.svg';
import { useAuth } from 'context/AuthContext';
import { toast } from 'react-toastify';
import { Link, RestartAlt } from '@mui/icons-material';
import { baseURL, getSECURE_API } from 'api';
import CopyToClipboard from 'react-copy-to-clipboard';

const getLabel = (pathname, role) =>
  role === 'agent'
    ? [...agentConfig, ...otherConfig].find((el) => el.path === pathname)?.title
    : role === 'admin'
      ? [...mainConfig, ...otherConfig].find((el) => el.path === pathname)?.title
      : '';

const NavContent = () => {
  const { pathname } = useLocation();
  const { user, setState } = useAuth();

  const [isRestartingCode, setIsRestartingCode] = useState(false);

  const handleRestartCode = async () => {
    try {
      setIsRestartingCode(true);
      const axios = getSECURE_API();
      const { data } = await axios.put(`${baseURL}/links/reset`);
      setState((st) => ({
        ...st,
        user: {
          ...st.user,
          user_link: data.link.link,
        },
      }));
      toast.success('Code regenerated successfully');
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message || 'Something went wrong');
    } finally {
      setIsRestartingCode(false);
    }
  };

  return (
    <Box {...displayFlexAlignItemsCenterJustifyContentSpaceBetween} width='100%'>
      <Typography token={tokens.FS26FW500LH31_2M} color={colors.greyF8} text={getLabel(pathname, user?.role)} />
      {user.role === 'agent' && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 10,
            alignItems: 'center',
            flexGrow: 1,
            justifyContent: 'center',
          }}
        >
          <Typography
            token={tokens.FS26FW500LH31_2Msdasd}
            color={colors.greyF8}
            text={'Referral Code'}
            style={{
              marginLeft: '3rem',
            }}
          />

          <Typography
            token={tokens.FS26FW500LH31_2Msdasd}
            color={colors.green61}
            text={user?.user_link}
            cursor='pointer'
            copyToClipboard
          />

          <CopyToClipboard
            text={`https://bitsweeps.vip?referral-code=${user?.user_link}`}
            onCopy={() => {
              toast.success('Link copied to clipboard');
            }}
          >
            <Tooltip title='Copy Referral Link'>
              <IconButton>
                <Link size={20} color='primary' />
              </IconButton>
            </Tooltip>
          </CopyToClipboard>

          {isRestartingCode ? (
            <CircularProgress size={20} color='primary' />
          ) : (
            <Tooltip title='Rotate Code'>
              <IconButton onClick={handleRestartCode}>
                <RestartAlt color='primary' />
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}
      <Box {...displayFlexAlignItemsCenterJustifyContentCenter} gap={'15px'}>
        <Box {...displayFlexAlignItemsCenterJustifyContentCenter} gap={'10px'} alignItems='end'>
          <Avatar
            src={calenderSvg}
            variant='square'
            sx={{
              width: '22px',
              height: '22px',
              '& img': {
                objectFit: 'contain',
              },
            }}
          />
          <Typography token={tokens.FS16FW500LH19_2M} color={colors.greyF8} text={new Date().toLocaleDateString()} />
        </Box>
        {/* <Box
          width={'1px'}
          height={'25px'}
          my={'auto'}
          backgroundColor={colors.whiteFF}
        /> */}
        {/* <NotificationSummaryManager /> */}
      </Box>
    </Box>
  );
};

export default NavContent;
